import React from 'react';
import PropTypes from 'prop-types';

import MembersSearch from './member-search';
import { MembersSortFieldDesktop } from '../member-sort-field';
import MembersFilterField from '../member-filter-field';
import styles from './member-header-desktop.scss';
import withTranslate from '../../hoc/with-translate';
import { ViewCardsIcon } from '../icons/view-cards-icon';
import { ViewListIcon } from '../icons/view-list-icon';
import { LAYOUT_GRID_VIEW, LAYOUT_LIST_VIEW } from '../../constants/layout-types';
import Icon from '../icon';

const classNames = require('classnames');

const MemberHeaderDesktop = ({
  search,
  onSearchChange,
  sort,
  sorts,
  onFilterChange,
  membersCount,
  displayMembersCount,
  displayMemberSortField,
  filter,
  filters,
  badge,
  onSortChange,
  t,
  onViewChange,
  onBadgeRemove,
  pageLayout,
}) => (
  <div
    className={classNames(styles.container, 'ma-primary-button-color', 'ma-all-members-icon-fill', 'ma-font-body-m')}
  >
    <div className={styles.sortByContainer}>
      <MembersFilterField
        className={classNames(styles.filter, 'ma-primary-font-color', 'ma-fill-primary-text')}
        value={filter}
        filters={filters}
        onChange={onFilterChange}
      />
      {displayMemberSortField && (
        <>
          <div className={classNames(styles.sortByText, 'ma-primary-font-color')}>{t('members-header.sort-by')}</div>
          <MembersSortFieldDesktop
            className={classNames(styles.sort, 'ma-primary-font-color', 'ma-fill-primary-text')}
            value={sort}
            sorts={sorts}
            onChange={onSortChange}
          />
        </>
      )}
    </div>
    <div className={styles.rightSide}>
      <div className={styles.listView} data-hook="am-layout-options">
        <button
          onClick={onViewChange(LAYOUT_GRID_VIEW)}
          className={styles.viewButton}
          data-hook="am-grid-button"
          aria-label={t('members-page.grid-view')}
        >
          <Icon
            iconClassName={pageLayout === LAYOUT_GRID_VIEW ? 'ma-all-members-icon-fill' : 'ma-fill-primary-text'}
            icon={<ViewCardsIcon />}
            tooltip="members-page.grid-view"
            placement="bottom"
          />
        </button>
        <button
          onClick={onViewChange(LAYOUT_LIST_VIEW)}
          className={styles.viewButton}
          data-hook="am-list-button"
          aria-label={t('members-page.list-view')}
        >
          <Icon
            iconClassName={pageLayout === LAYOUT_LIST_VIEW ? 'ma-all-members-icon-fill' : 'ma-fill-primary-text'}
            icon={<ViewListIcon />}
            tooltip="members-page.list-view"
            placement="bottom"
          />
        </button>
      </div>
      <MembersSearch
        className={classNames('ma-primary-font-color', 'ma-fill-primary-text')}
        count={membersCount}
        displayCount={displayMembersCount}
        value={search}
        badge={badge}
        onBadgeRemove={onBadgeRemove}
        onChange={onSearchChange}
      />
    </div>
  </div>
);

MemberHeaderDesktop.propTypes = {
  sort: PropTypes.string.isRequired,
  sorts: PropTypes.object,
  onSortChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  search: PropTypes.string,
  filter: PropTypes.string,
  filters: PropTypes.object,
  badge: PropTypes.object,
  onSearchChange: PropTypes.func.isRequired,
  onBadgeRemove: PropTypes.func.isRequired,
  onViewChange: PropTypes.func.isRequired,
  pageLayout: PropTypes.number,
  membersCount: PropTypes.number,
  displayMembersCount: PropTypes.bool,
  displayMemberSortField: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslate(MemberHeaderDesktop);
